const updateRedirectUrl = redirectUrl => ({
    type: 'UPDATE_REDIRECT_URL',
    redirectUrl
});

const actions = {
    updateRedirectUrl
};

export default actions;